export const environment = {
  production: false,
  bucketUrlImages: 'https://studio-e-showroom-test.akiru.se/images/',
  bucketUrlVideos: 'https://studio-e-showroom-test.akiru.se/videos/',
  bucketUrlDocs: 'https://studio-e-showroom-test.akiru.se/docs/'
}
